module.exports = __webpack_public_path__ + "static/media/profile-placeholder.639a7f55.png";